module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "crowd-or-rais"
  }, [_c('router-link', {
    staticClass: "crowd-or",
    attrs: {
      "to": "/crowdfunding"
    }
  }, [_vm._v("CROWDFUNDING")]), _vm._v(" "), _c('span', {
    staticClass: "or"
  }, [_vm._v("or")]), _vm._v(" "), _c('router-link', {
    staticClass: "rais-or",
    attrs: {
      "to": "/fundraising"
    }
  }, [_vm._v("FUNDRAISING?")])], 1), _vm._v(" "), _c('h1', {
    staticClass: "big-slogan-blue"
  }, [_vm._v(_vm._s(_vm.$t("main.header")))]), _vm._v(" "), _c('h2', {
    staticClass: "mb-50"
  }, [_vm._v(_vm._s(_vm.$t("main.subtitle")))])]), _vm._v(" "), (_vm.promotedProjects.length) ? _c('slider', {
    attrs: {
      "projects": _vm.promotedProjects
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('project-tabs', {
    attrs: {
      "crowdfunding": true,
      "projects": _vm.crowd
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-30"
  }, [_c('div', {
    staticClass: "all-categories"
  }, [_c('strong', [_vm._v("CROWDFUNDING:")]), _vm._v(" " + _vm._s(_vm.$t("main.allCategories")))]), _vm._v(" "), _c('div', {
    staticClass: "all-categories-list-crowd"
  }, [_c('ul', {
    staticClass: "list-inline"
  }, _vm._l((_vm.crowdCategories), function(category) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          name: 'crowdfunding',
          query: {
            category_id: category.id,
            category: category.name
          }
        }
      }
    }, [_vm._v(_vm._s(category.name))])], 1)
  }), 0)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "container-fluid domore-yellow-light-bgd"
  }, [_c('div', {
    staticClass: "container fundraising-home-box"
  }, [_c('p', {
    staticClass: "fundraising-home-box-title domore-yellow"
  }, [_vm._v("FUNDRAISING")]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t("main.fundraisingTitle")))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t("main.fundraisingSubtitle")))])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('project-tabs', {
    attrs: {
      "crowdfunding": false,
      "projects": _vm.fundraising
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-50"
  }, [_c('div', {
    staticClass: "all-categories"
  }, [_c('strong', [_vm._v("FUNDRAISING:")]), _vm._v(" " + _vm._s(_vm.$t("main.allCategories")))]), _vm._v(" "), _c('div', {
    staticClass: "all-categories-list-rais"
  }, [_c('ul', {
    staticClass: "list-inline"
  }, _vm._l((_vm.raisCategories), function(category) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          name: 'fundraising',
          query: {
            category_id: category.id,
            category: category.name
          }
        }
      }
    }, [_vm._v(_vm._s(category.name))])], 1)
  }), 0)])])], 1), _vm._v(" "), _c('why-do-more'), _vm._v(" "), _c('partners')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-30 slider-big",
    staticStyle: {
      "margin-top": "-20px"
    }
  }, [_c('div', {
    staticClass: "carousel slide",
    attrs: {
      "id": "carousel-slider-big",
      "data-ride": "carousel"
    }
  }, [_c('ol', {
    staticClass: "carousel-indicators"
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "data-target": "#carousel-slider-big",
      "data-slide-to": "0"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-target": "#carousel-slider-big",
      "data-slide-to": "1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "carousel-inner",
    attrs: {
      "role": "listbox"
    }
  }, [_c('div', {
    staticClass: "item active"
  }, [_c('div', {
    staticClass: "slider-wrapper"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": require("assets/img/slide-big1.jpg")
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "slider-wrapper"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": require("assets/img/slide-big2.jpg")
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-592d3671"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Main.vue
// module id = 806
// module chunks = 1